import { render, staticRenderFns } from "./delivered.vue?vue&type=template&id=2e733fca&scoped=true"
import script from "./delivered.vue?vue&type=script&lang=js"
export * from "./delivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e733fca",
  null
  
)

export default component.exports